// extracted by mini-css-extract-plugin
export default {"button":"Button_button__E2EFk","inverted":"Button_inverted__WK-JS","white":"Button_white__1eZc3","inverted-white":"Button_inverted-white__XSfgn","red":"Button_red__dD+SD"};